<template>
  <div class="recipe_add">
    <br />

    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'SignCheck' }">申请处方</el-breadcrumb-item>
      <el-breadcrumb-item>申请处方</el-breadcrumb-item>
    </el-breadcrumb>

    <hr />

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="申请处方" name="first">
        <el-container>
          <el-header>
            <!-- 空置区域 -->
          </el-header>
          <el-main>
            <div class="form-region-header font-30">个人信息</div>
            <el-form ref="form" :model="form" label-width="200px">
              <table>
                <tr>
                  <td>
                    <el-form-item label="患者姓名">
                      <el-input v-model="form.name" :disabled="disabled"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item label="患者性别">
                      <el-radio v-model="form.sex" label="男" :disabled="disabled">男</el-radio>
                      <el-radio v-model="form.sex" label="女" :disabled="disabled">女</el-radio>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="患者年龄">
                      <el-input v-model="form.age" type="number" :disabled="disabled"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item label="患者身份证号(选填)">
                      <el-input
                        v-model="form.ctizenID"
                        placeholder="请输入患者身份证号"
                        clearable
                        :disabled="disabled"
                      ></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="患者手机号码">
                      <el-input v-model="form.phone" type="number" clearable disabled></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item label="特殊人群">
                      <el-radio v-model="form.special" label="是" :disabled="disabled">是</el-radio>
                      <el-radio v-model="form.special" label="否" :disabled="disabled">否</el-radio>
                    </el-form-item>
                    <div v-if="form.special == '是' ">
                      <el-form-item>
                        <el-radio v-model="form.specialdetail" label="备孕" :disabled="disabled">备孕</el-radio>
                        <el-radio v-model="form.specialdetail" label="孕妇" :disabled="disabled">孕妇</el-radio>
                        <el-radio v-model="form.specialdetail" label="产妇" :disabled="disabled">产妇</el-radio>
                        <el-radio v-model="form.specialdetail" label="哺乳期" :disabled="disabled">哺乳期</el-radio>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
              </table>
            </el-form>
          </el-main>
          <el-main>
            <div class="form-region-header font-30">病史信息</div>
            <el-form ref="form" :model="form" label-width="200px">
              <table>
                <tr>
                  <td>
                    <el-form-item label="药物/其他过敏史">
                      <el-radio v-model="form.hisAllergy" label="是" :disabled="disabled">是</el-radio>
                      <el-radio v-model="form.hisAllergy" label="否" :disabled="disabled">否</el-radio>
                      <div v-if="form.hisAllergy == '是' ">
                        <el-form-item>
                          <el-input v-model="form.allergyDesc" :disabled="disabled"></el-input>
                        </el-form-item>
                      </div>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="是否肝功能不全">
                      <el-radio v-model="form.hisLiver" label="是" :disabled="disabled">是</el-radio>
                      <el-radio v-model="form.hisLiver" label="否" :disabled="disabled">否</el-radio>
                    </el-form-item>
                    <div v-if="form.hisLiver == '是' ">
                      <el-form-item>
                        <el-input v-model="form.liverillDesc" :disabled="disabled"></el-input>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="是否肾功能不全">
                      <el-radio v-model="form.hisKidney" label="是" :disabled="disabled">是</el-radio>
                      <el-radio v-model="form.hisKidney" label="否" :disabled="disabled">否</el-radio>
                    </el-form-item>
                    <div v-if="form.hisKidney == '是' ">
                      <el-form-item>
                        <el-input v-model="form.kidneyillDesc" :disabled="disabled"></el-input>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="是否有高血压历史">
                      <el-radio v-model="form.hisHypertension" label="是" :disabled="disabled">是</el-radio>
                      <el-radio v-model="form.hisHypertension" label="否" :disabled="disabled">否</el-radio>
                    </el-form-item>
                    <div v-if="form.hisHypertension == '是' ">
                      <el-form-item label="高压">
                        <el-input
                          v-model="form.highHypertension"
                          type="number"
                          :disabled="disabled"
                        >
                          <template slot="append">mmHg</template>
                        </el-input>
                      </el-form-item>
                      <el-form-item label="低压">
                        <el-input v-model="form.lowHypertension" type="number" :disabled="disabled">
                          <template slot="append">mmHg</template>
                        </el-input>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="是否有糖尿病史">
                      <el-radio v-model="form.hisDiabete" label="是" :disabled="disabled">是</el-radio>
                      <el-radio v-model="form.hisDiabete" label="否" :disabled="disabled">否</el-radio>
                    </el-form-item>
                    <div v-if="form.hisDiabete == '是' ">
                      <el-form-item>
                        <el-input v-model="form.diabetesDesc" :disabled="disabled"></el-input>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="是否有心脏病史">
                      <el-radio v-model="form.hisHeart" label="是" :disabled="disabled">是</el-radio>
                      <el-radio v-model="form.hisHeart" label="否" :disabled="disabled">否</el-radio>
                    </el-form-item>
                    <div v-if="form.hisHeart == '是' ">
                      <el-form-item>
                        <el-input v-model="form.heartDiseaseDesc" :disabled="disabled"></el-input>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="是否有其他特殊疾病">
                      <el-radio v-model="form.hisOther" label="是" :disabled="disabled">是</el-radio>
                      <el-radio v-model="form.hisOther" label="否" :disabled="disabled">否</el-radio>
                    </el-form-item>
                    <div v-if="form.hisOther == '是' ">
                      <el-form-item>
                        <el-input v-model="form.otherDiseaseDesc" :disabled="disabled"></el-input>
                      </el-form-item>
                    </div>
                  </td>
                </tr>
              </table>
            </el-form>
          </el-main>
          <el-footer>
            <el-button @click="disabled ? gotomodify() : updateClicked()" v-text="modifyText"></el-button>
            <el-button type="primary" @click="gotonext" :disabled="!disabled">下一步</el-button>
          </el-footer>
        </el-container>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "DoctorApproval",
  data() {
    return {
      activeName: "first",
      disabled: true,
      // modifyText : disabled ? "修改信息":"保存",
      modifyText: "修改信息",

      updateUserAPI: "http://121.196.220.228:30002/updateUser",
      registedDetailAPI: "http://121.196.220.228:30002/isRegistered",
      form: {
        name: "",
        phone: "",
        sex: "女",
        age: "",
        ctizenID: "",
        special: "否",
        specialdetail: "备孕",
        hisAllergy: "否",
        allergyDesc: "",
        hisLiver: "否",
        liverillDesc: "",
        hisKidney: "否",
        kidneyillDesc: "",
        hisHypertension: "否",
        highHypertension: "",
        lowHypertension: "",
        hisDiabete: "否",
        diabetesDesc: "",
        hisHeart: "否",
        heartDiseaseDesc: "",
        hisOther: "否",
        otherDiseaseDesc: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        medicine: [
          { required: true, message: "请选择药品名字", trigger: "change" }
        ]
      }
    };
  },
  props: {
    msg: String
  },
  methods: {
    gotomodify() {
      this.disabled = false;
      this.modifyText = "保存";
    },
    updateClicked() {
      if (this.form.special == "是" && this.form.sex == "男") {
        alert("患者性别与特殊人群冲突");
      } else if (
        this.form.hisHypertension == "是" &&
        (this.form.highHypertension.trim() == "" ||
          this.form.lowHypertension.trim() == "")
      ) {
        alert("请正确添加血压数值");
      } else {
        this.$confirm("是否提交修改?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {

        this.modifyText = "修改信息";
        this.disabled = true;
            var SpecialGroupType;
            if (this.form.special == "否") {
              SpecialGroupType = 1;
            } else {
              switch (this.form.specialdetail) {
                case "备孕":
                  SpecialGroupType = 2;
                  break;
                case "孕妇":
                  SpecialGroupType = 3;
                  break;
                case "产妇":
                  SpecialGroupType = 4;
                  break;
                case "哺乳期":
                  SpecialGroupType = 5;
                  break;
                default:
                  SpecialGroupType = 2;
                  break;
              }
            }
            var highPressureDesc = "";
            if (this.form.hisHypertension == "是") {
              highPressureDesc =
                "高压" +
                this.form.highHypertension +
                "mmgh,低压" +
                this.form.lowHypertension +
                "mmgh";
            }
            let params = {
              name: this.form.name,
              phone: this.form.phone + "",
              sex: this.form.sex == "男" ? 1 : 2,
              age: this.form.age,
              ctizenID: this.form.ctizenID + "",
              SpecialGroupType: SpecialGroupType,
              isAllergy: this.form.hisAllergy == "否" ? 0 : 1,
              allergyDesc:
                this.form.hisAllergy == "否" ? "" : this.form.allergyDesc,
              isliverill: this.form.hisLiver == "否" ? 0 : 1,
              liverillDesc:
                this.form.hisLiver == "否" ? "" : this.form.liverillDesc,
              isKidneyill: this.form.hisKidney == "否" ? 0 : 1,
              kidneyillDesc:
                this.form.hisKidney == "否" ? "" : this.form.kidneyillDesc,
              isHighPressure: this.form.hisHypertension == "否" ? 0 : 1,
              highPressureDesc:
                this.form.hisHypertension == "否" ? "" : highPressureDesc,
              isDiabetes: this.form.hisDiabete == "否" ? 0 : 1,
              diabetesDesc:
                this.form.hisDiabete == "否" ? "" : this.form.diabetesDesc,
              isHeartDisease: this.form.hisHeart == "否" ? 0 : 1,
              heartDiseaseDesc:
                this.form.hisHeart == "否" ? "" : this.form.heartDiseaseDesc,
              isOtherDisease: this.form.hisOther == "否" ? 0 : 1,
              otherDiseaseDesc:
                this.form.hisOther == "否" ? "" : this.form.otherDiseaseDesc,
              authToken: sessionStorage.getItem("authToken")
            };
            this.axios
              .post(this.updateUserAPI, qs.stringify(params))
              .then(function(res){
                if (res.data.data.result === "fail") {
                    alert("更新失败");
                  } else {
                    alert("更新成功");
              }}).catch((e) => { alert(e+"，登录超时，请重新登录");});
          })
          .catch(() => {});
      }
    },
    gotonext() {
      this.$router.replace("/RecipeAdd2");
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onSubmit(formName) {
      console.log(formName);
      this.$confirm("是否同意?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.DoctorApprovalApi)
            .then(response => (this.info = response.data))
            .catch((e) => { alert(e+"，登录超时，请重新登录");});
        })
        .catch(() => {
          //this.$message({
          //  type: 'info',  // success
          //  message: '已取消删除'
          // });
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }else{
    var __this = this;
    var phoneNumber = sessionStorage.getItem("userPhone");
    //console.log("phoneNumber,"+phoneNumber);
    let params = {
      phoneNumber: phoneNumber,
      authToken: sessionStorage.getItem("authToken")
      };
    this.axios
      .post(__this.registedDetailAPI, qs.stringify(params))
      .then(function(res) {
        var responseData = res.data;
        console.log(responseData);
        if (responseData.data.result === "fail") {
          alert(responseData.err.code);
        } else {
          console.log(responseData.data.result);
          console.log(responseData.data.registered);
          if (responseData.data.registered === true) {
            __this.form.name = responseData.data.registerInfo.name;
            __this.form.sex =
              responseData.data.registerInfo.sex === 1 ? "男" : "女";
            __this.form.phone = responseData.data.registerInfo.phone;
            __this.form.age = responseData.data.registerInfo.age;
            __this.form.ctizenID = responseData.data.registerInfo.ctizenID;

            __this.form.special =
              responseData.data.registerInfo.SpecialGroupType === 1
                ? "否"
                : "是";
            if (responseData.data.registerInfo.SpecialGroupType !== 1) {
              __this.form.special = "是";
              console.log(responseData.data.registerInfo.SpecialGroupType);
              switch (responseData.data.registerInfo.SpecialGroupType) {
                case 2:
                  __this.form.specialdetail = "备孕";
                  break;
                case 3:
                  __this.form.specialdetail = "孕妇";
                  break;
                case 4:
                  __this.form.specialdetail = "产妇";
                  break;
                case 5:
                  __this.form.specialdetail = "哺乳期";
                  break;
              }
            } else {
              __this.form.special = "否";
            }

            __this.form.hisAllergy =
              responseData.data.registerInfo.isAllergy === 1 ? "是" : "否";
            __this.form.allergyDesc =
              responseData.data.registerInfo.allergyDesc;
            __this.form.hisLiver =
              responseData.data.registerInfo.isliverill === 1 ? "是" : "否";
            __this.form.liverillDesc =
              responseData.data.registerInfo.liverillDesc;
            __this.form.hisKidney =
              responseData.data.registerInfo.isKidneyill === 1 ? "是" : "否";
            __this.form.kidneyillDesc =
              responseData.data.registerInfo.kidneyillDesc;
            __this.form.hisHypertension =
              responseData.data.registerInfo.isHighPressure === 1 ? "是" : "否";
            if (
              !responseData.data.registerInfo.isHighPressure &&
              typeof responseData.data.registerInfo.isHighPressure !=
                "undefined" &&
              responseData.data.registerInfo.isHighPressure != 0
            ) {
              __this.form.highHypertension = "";
              __this.form.lowHypertension = "";
            } else {
              if (
                !responseData.data.registerInfo.highPressureDesc &&
                typeof responseData.data.registerInfo.highPressureDesc !=
                  "undefined" &&
                responseData.data.registerInfo.highPressureDesc != 0
              ) {
                __this.form.highHypertension = "";
                __this.form.lowHypertension = "";
              } else {
                var arrHypertension = responseData.data.registerInfo.highPressureDesc.split(
                  /[高压 mmgh,低压 mmgh]/
                );
                if (arrHypertension.length == 14) {
                  __this.form.highHypertension = arrHypertension[2];
                  __this.form.lowHypertension = arrHypertension[9];
                } else {
                  __this.form.highHypertension = 0;
                  __this.form.lowHypertension = 0;
                }
              }
            }
            __this.form.hisDiabete =
            __this.form.diabetesDesc =
              responseData.data.registerInfo.diabetesDesc;
            __this.form.hisHeart =
              responseData.data.registerInfo.isHeartDisease === 1 ? "是" : "否";
            __this.form.heartDiseaseDesc =
              responseData.data.registerInfo.heartDiseaseDesc;
            __this.form.hisOther =
              responseData.data.registerInfo.isOtherDisease === 1 ? "是" : "否";
            __this.form.otherDiseaseDesc =
              responseData.data.registerInfo.otherDiseaseDesc;
          } else {
            //TODO: handler this error.
            __this.$router.replace("/SignCheck");
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
